import React from 'react';
import Button from '$components/library/Button';
import { generatePath, Link } from 'react-router-dom';
import routes from '@achievable-me/tundra-wizard/routes';
import styles from './styles.scss';

const achievableSrc = 'https://d31dt0mxu5que4.cloudfront.net/logo-black-with-text.png';
const collegeSrc =
  'https://d31dt0mxu5que4.cloudfront.net/logos/partners/logo-university.png';
const denverSrc = 'https://d31dt0mxu5que4.cloudfront.net/logos/partners/logo-du.png';
const screenshotSrc =
  'https://d31dt0mxu5que4.cloudfront.net/achievable/achievable-large-hero-finra-series-7.png';

const getContent = ({ code }) => {
  let content = {
    partnerSrc: collegeSrc,
    copy: 'Achievable is proud to provide FINRA SIE study materials for University students.',
    promo: 'EDU_4D46',
    productSlug: 'finra-sie',
  };

  switch (code) {
    case 'denver': {
      content = {
        partnerSrc: denverSrc,
        copy: 'Achievable is proud to provide FINRA SIE study materials for University of Denver students.',
        promo: 'DENVER_D3DA',
        productSlug: 'finra-sie',
      };
      break;
    }
    default: {
      break;
    }
  }

  return content;
};

const Enroll = (props) => {
  const { code } = props;

  const { partnerSrc, copy, productSlug, promo } = getContent({ code });

  const path = generatePath(routes.study.purchase, {
    productSlug,
  });
  const query = `#p=${promo}`;
  const to = `${path}${query}`;

  return (
    <div className={styles.layout}>
      <div className={styles.well}>
        <div className={styles.header}>
          <img src={achievableSrc} className={styles.achievableLogo} />
        </div>
        <div className={styles.content}>
          <div className={styles.main}>
            <div className={styles.welcome}>Welcome</div>
            <img src={partnerSrc} className={styles.partnerLogo} />
            <div className={styles.info}>{copy}</div>
            <Link to={to}>
              <Button color="teal">Enroll now</Button>
            </Link>
          </div>
          <img src={screenshotSrc} className={styles.screenshot} />
        </div>
      </div>
    </div>
  );
};

export default Enroll;
